export enum UsageType {
  MONTHLY = "MONTHLY",
  LIFETIME = "LIFETIME",
}
